import axiosInstance from "./authentication/axiosInstance";

export const notificationTrackerService = {

    getUnseenNotificationsByUserId: async (userId) => {
        const response = await axiosInstance.get(`/notification/notifications/unseen/${userId}`);
        return response.data;
    },

    markNotificationAsSeenById: async (notificationId) => {
        const response = await axiosInstance.post(`/notification/notifications/seen/${notificationId}`);
        return response.data;
    },

    getUnseenNotificationForTodayBirthdayAndJoinDayByUserId: async (userId) => {
        const response = await axiosInstance.get(`/notification/notifications/unseen/today/${userId}`);
        return response.data;
    },

    notifyLeaveApplied: async (leaveId, startDate, endDate) => {
        const response = await axiosInstance.post(`/notification/leave/applied`, {
            parentId: leaveId,
            startDate,
            endDate,
        });
        return response.data;
    },

    notifyLeaveCancellationApplied: async (leaveId, startDate, endDate) => {
        const response = await axiosInstance.post(`/notification/leave/cancellation-applied`, {
            parentId: leaveId,
            startDate,
            endDate,
        });
        return response.data;
    },

    notifyLeaveStatusUpdated: async (userId, leaveId, status, startDate, endDate) => {
        const response = await axiosInstance.post(`/notification/leave/status-updated`, {
            userId,
            parentId: leaveId,
            status,
            startDate,
            endDate,
        });
        return response.data;
    },

};